<template>
    <div>
        <!-- Shape -->
        <div class="position-relative">
            <div class="shape shape-bottom shape-fluid-x svg-shim text-dark">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"/>
                </svg>
            </div>
        </div>

        <footer class="py-8 py-md-11 bg-dark">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-4 col-lg-3 text-center">
                        <img src="../assets/img/logo-dark-bg.svg" alt="..." class="img-fluid mb-8">
                        <p>
                            <small class="copyright mt-3 text-muted">{{year}} © AcreCX</small>
                        </p>
                    </div>
                    <div class="col-6 col-md-4 offset-md-4 col-lg-2 offset-lg-0">
                        <h6 class="font-weight-bold text-uppercase text-gray-700">
                            Company
                        </h6>
                        <ul class="list-unstyled text-muted font-size-sm mb-0">
                            <li class="mb-3">
                                <router-link class="text-reset" @click.native="backToTop" :to="{name: 'about'}">
                                    About
                                </router-link>
                            </li>
                            <li class="mb-3">
                                <router-link class="text-reset" @click.native="backToTop" :to="{name: 'sales'}">
                                    Sales
                                </router-link>
                            </li>
                            <li class="mb-3">
                                <router-link class="text-reset" @click.native="backToTop" :to="{name: 'terms'}">
                                    Terms
                                </router-link>
                            </li>
                            <li class="mb-3">
                                <router-link :to="{name: 'privacy'}" @click.native="backToTop" class="text-reset">
                                    Privacy
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-6 col-md-4 col-lg-2">
                        <h6 class="font-weight-bold text-uppercase text-gray-700">
                            Products
                        </h6>
                        <ul class="list-unstyled text-muted font-size-sm mb-6 mb-md-8 mb-lg-0">
                            <li class="mb-3">
                                <router-link :to="{name: 'marketplace'}" class="text-reset">
                                    Marketplace
                                </router-link>
                            </li>
                            <li class="mb-3">
                                <router-link :to="{name: 'express'}" class="text-reset">
                                    Express
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-6 col-md-4 col-lg-2">
                        <h6 class="font-weight-bold text-uppercase text-gray-700">
                            Developers
                        </h6>
                        <ul class="list-unstyled text-muted font-size-sm mb-6 mb-md-8 mb-lg-0">
                            <li class="mb-3">
                                <a class="text-reset" @click.native="backToTop" href="https://docs.acrecx.com" target="_blank">
                                    API
                                </a>
                            </li>
                            <li class="mb-3">
                                <router-link class="text-reset" @click.native="backToTop" :to="{name: 'changelog'}">
                                    Changelog
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-6 col-md-4 col-lg-3">
                        <h6 class="font-weight-bold text-uppercase text-gray-700">
                            Contact Us
                        </h6>
                        <small>
                            <address class="text-muted mb-2">
                                Wilhelmina van Pruisenweg 35<br>
                                2595 AN Den Haag <br>
                                The Netherlands <br><br>
                                <a href="mailto:info@acrecx.com" class="text-muted mb-2">info@acrecx.com</a><br>
                                <a href="tel:+13115552368" class="text-muted mb-2">+1 403 464 9440</a>
                            </address>
                        </small>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    export default {
        name: "MainFooter",
        data() {
            return {
                year: new Date().getFullYear()
            }
        },
        methods: {}
    }
</script>

<style scoped>
    .img-fluid {
        max-width: 75%;
    }
</style>